import { render } from "./SearchModule.vue?vue&type=template&id=39c1de97"
import script from "./SearchModule.vue?vue&type=script&lang=js"
export * from "./SearchModule.vue?vue&type=script&lang=js"
script.render = render

export default script